<script>
import './ProfileButton.scss'
import BaseDropdown from '@/components(new)/UI/Dropdowns/BaseDropdown/BaseDropdown.vue'
import CustomButton from '../CustomButton/CustomButton.vue'

export default {
  props: {
    nameUser: {
      type: String,
      required: false,
      default: 'Usuário'
    },
    namePerfil: {
      type: String,
      required: false,
      default: '-'
    },
    emailUser: {
      type: String,
      required: false,
      default: '-'
    },
    opcoesProfileButton: {
      type: Array,
      default: () => [
        { text: 'Ação 1', action: () => alert('Ação 1 clicada') },
        { text: 'Ação 2', action: () => alert('Ação 2 clicada') }
      ]
    },
    ButtonSair: {
      type: Object,
      default: () => {
        return {
          text: 'Sair',
          action: () => alert('Ação 1 clicada')
        }
      }

    }
  },
  components: {
    BaseDropdown,
    CustomButton
  },
  methods: {
    getPrimeiroEUltimoNome (nomeCompleto) {
      const partes = nomeCompleto.trim().split(/\s+/)
      if (partes.length === 1) {
        return nomeCompleto
      }
      const primeiroNome = partes[0]
      const ultimoNome = partes[partes.length - 1]
      return `${primeiroNome} ${ultimoNome}`
    }
  }
}
</script>

<template>
  <BaseDropdown modeDropdown="Custom" :opcoesDropdown="opcoesProfileButton">
    <template #dropdown-trigger>
      <button id="buttonDropdown">
        <div id="containerIconUser">
          <i class="el-icon-user-solid" style="margin-left: 0px; padding: 0.3rem;"></i>
        </div>
        <div id="nameUser" class="ml-1 mr-1">
          <span class="poppins-regular">Olá, </span>
          <span class="poppins-bold">
              {{ getPrimeiroEUltimoNome(nameUser) }}
          </span>
        </div>
        <i id="iconArrow" class="el-icon-arrow-down"></i>
      </button>
    </template>
    <template #custom-content>
      <div id="containerDropdown">
        <div>
          <div class="poppins-semibold">{{ namePerfil }}</div>
          <div class="poppins-regular text-sm">{{ emailUser }}</div>
        </div>
        <div id="LineSeparatorDropdown"></div>
        <div>
          <el-dropdown-item
            v-for="(option, index) in opcoesProfileButton"
            :key="index"
            :command="option"
            :disabled="option.disabled"
            :divided="option.divided"
            :icon="option.icon"
            v-show="option.visible !== false"
          >
            <div class="poppins-semibold color-primary">{{ option.text }}</div>
          </el-dropdown-item>
        </div>
        <div id="LineSeparatorDropdown"></div>
        <div class="flex-end">
          <CustomButton
          type="OutlinedButton" StyleSheet="width: 6rem"
          :text="ButtonSair.text" @click="ButtonSair.action" />
        </div>
      </div>
    </template>
  </BaseDropdown>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Buttons/ProfileButton/ProfileButton.vue